export const deepKeys = (object: object, path = []): string[] =>
  Object(object) === object
    ? Object.entries(object).flatMap(([key, value]) => deepKeys(value, [...path, key]))
    : [path.join('.')];
